import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { ItemLocalization, Language } from '../../classes/language.class';

export const featureKey = 'languages';

export interface IState {
  isLoading: boolean;
  langs: ILangState;
  localization: IItemLocalizationState;
}

export interface ILangState extends EntityState<Language> {
  isLoading: boolean;
  selected: string;
}

export const languagesAdapter: EntityAdapter<Language> = createEntityAdapter<Language>({
  selectId: (item) => item.Code!,
  sortComparer: false,
});

export const initialLanguagesState: ILangState = languagesAdapter.getInitialState({
  isLoading: false,
  selected: 'en',
});

export interface IItemLocalizationState extends EntityState<ItemLocalization> {
  isLoading: boolean;
  dev?: boolean;
}

export const itemLocalizationAdapter: EntityAdapter<ItemLocalization> = createEntityAdapter<ItemLocalization>({
  selectId: (item) => item.Key!,
  sortComparer: false,
});

export const initialItemLocalizationListState: IItemLocalizationState = itemLocalizationAdapter.getInitialState({
  isLoading: false,
});

export const initialState: IState = {
  isLoading: false,
  langs: initialLanguagesState,
  localization: initialItemLocalizationListState,
};
